// extracted by mini-css-extract-plugin
module.exports = {"title":"UserEdidPage_title__1JXQz","buttonFooter":"UserEdidPage_buttonFooter__2rbUd","link":"UserEdidPage_link__3XBd3","mr_10":"UserEdidPage_mr_10__3Y9FN"};